// extracted by mini-css-extract-plugin
export var text = "_9f-0";